export const normalizeTagValue = (value) => {
    if (value == null) {
        return '';
    }
    return typeof value === 'string'
        ? value.trim().toLowerCase()
        : String(value).trim().toLowerCase();
};

export const formatTagLabel = (value) => {
    if (value == null) {
        return '';
    }
    if (typeof value === 'string') {
        return value.trim();
    }
    return String(value).trim();
};
